<div>
  <p-select
    [options]="options()"
    [ngModel]="selectedValue()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    (onChange)="onSelectionChange($event)"
    [loading]="isLoading()"
    [attr.data-testid]="'directus-select-' + dropdownKey()"
    [appendTo]="appendTo()"
    [filter]="filter()"
    filterBy="label"
    class="w-full"
  >
  </p-select>
</div>
